import React from 'react';
import { CompetitionsTrapChallengeGroup } from 'src/domains/sportsbook/webview/components/containers/competitionsTrapChallenge/CompetitionsTrapChallengeGroup';
import { HorseRacingSortOrderType } from 'src/domains/sportsbook/webview/components/raceCard/RaceCompetition.state';
import { RaceFiltersState } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/RaceFiiters.state';
import { TabItemRawType } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/RaceDetails.types';
import { RaceSummary } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummary';
import { RaceSummaryBettingWithout } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummaryBettingWithout';
import { RaceSummaryCast } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummaryCast';
import { RaceSummaryMatchBets } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummaryMatchBets';
import { ExtraPlacesSummary } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/extraPlacesSummary/ExtraPlacesSummary';
import { LengthenTheOddsSummary } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/lengthenTheOddsSummary/LengthenTheOddsSummary';
import { RaceSummarySubRaces } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummarySubRaces';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { PlaceOnlySummary } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/placeOnlySummary/PlaceOnlySummary';

export const getFilters = (
    state: RaceFiltersState,
    race: EventModel,
    sortOrder: HorseRacingSortOrderType
): Array<TabItemRawType> => {
    const markets: Array<TabItemRawType> = [];

    const { getTranslation } = state.language;

    for (const market of race.marketRaceWinnerAll) {
        if (market.display === false) {
            continue;
        }

        markets.push({
            key: 'Win or Ew',
            label: getTranslation('events.racecard.win-or-ew.label:new-racecard', 'Win / Eachway'),
            content: (
                <RaceSummary
                    sortOrder={sortOrder}
                    key='Win / Ew'
                    marketId={market.id2}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('Win or Ew');
            },
            showBogForMarket: true,
        });

        if (market.forecastsOffered) {
            markets.push({
                key: 'forecast-tricast',
                label: getTranslation('events.racecard.forecast-tricast.label', 'Forecast / Tricast'),
                content: (
                    <RaceSummaryCast
                        sortOrder={sortOrder}
                        key='forecast-tricast'
                        marketId={market.id2}
                    />
                ),
                onClick: () => {
                    state.setActiveFilterId('forecast-tricast');
                },
                showBogForMarket: true,
            });
        }
    }

    if (race.marketWinOnly !== null) {
        markets.push({
            key: 'win-only',
            label: getTranslation('events.racecard.win-only.label', 'Win Only'),
            content: (
                <RaceSummary
                    sortOrder={sortOrder}
                    key='win-only'
                    marketId={race.marketWinOnly.id2}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('win-only');
            },
            showBogForMarket: false,
        });
    }

    if (race.marketExtraPlaces.length > 0 && race.marketExtraPlaces[0] !== undefined) {
        markets.push({
            key: 'extra-places',
            label: getTranslation('events.racecard.extra-places.label', 'Extra Places'),
            content: (
                <ExtraPlacesSummary
                    key='extra-places'
                    race={race}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('extra-places');
            },
            showBogForMarket: false,
        });
    }

    if (race.marketWithout.length > 0) {
        markets.push({
            key: 'betting-without',
            label: getTranslation('events.racecard.betting-without.label', 'Betting Without'),
            content: (
                <RaceSummaryBettingWithout
                    key='betting-without'
                    eventId={race.id2}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('betting-without');
            },
            showBogForMarket: false,
        });
    }

    if (race.marketMatchBet.length > 0 && race.marketMatchBet[0] !== undefined) {
        markets.push({
            key: 'match-bets',
            label: getTranslation('events.racecard.match-bets.label', 'Match Bets'),
            content: (
                <RaceSummaryMatchBets
                    key='match-bets'
                    eventId={race.id2}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('match-bets');
            },
            showBogForMarket: false,
        });
    }

    if (race.marketSubRace.length > 0) {
        markets.push({
            key: 'sub-race',
            label: getTranslation('events.racecard.sub-race.label', 'Sub Races'),
            content: (
                <RaceSummarySubRaces
                    key='sub-races'
                    eventId={race.id2}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('sub-race');
            },
            showBogForMarket: false,
        });
    }

    if (race.marketTrapChallenge.length > 0) {
        markets.push({
            key: 'trap-challenge',
            label: getTranslation('events.racecard.trap-challenge.label', 'Trap Challenge'),
            content: <CompetitionsTrapChallengeGroup events={[race]} />,
            onClick: () => {
                state.setActiveFilterId('trap-challenge');
            },
            showBogForMarket: false,
        });
    }

    if (race.marketLengthenTheOdds.length > 0) {
        markets.push({
            key: 'lengthen-the-odds',
            label: getTranslation('events.racecard.lengthen-the-odds.label', 'Lengthen The Odds'),
            content: (
                <LengthenTheOddsSummary
                    key='lengthen-the-odds'
                    race={race}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('lengthen-the-odds');
            },
            showBogForMarket: false,
        });
    }

    if (race.marketTopFinish.length > 0) {
        markets.push({
            key: 'place-only',
            label: getTranslation('events.racecard.place-only.label', 'To be Placed'),
            content: (
                <PlaceOnlySummary
                    key='place-only'
                    race={race}
                />
            ),
            onClick: () => {
                state.setActiveFilterId('place-only');
            },
            showBogForMarket: false,
        });
    }

    return markets;
};

export const getActiveFilterContent = (
    state: RaceFiltersState,
    filters: Array<TabItemRawType>
): TabItemRawType | null => {
    const active = state.activeFilterId;

    for (const item of filters) {
        if (item.key === active) {
            return item;
        }
    }

    const firstItem = filters[0];
    if (firstItem !== undefined) {
        return firstItem;
    }

    return null;
};
